import { getEarliestBlockDate, timestampToDateAtTime } from './historyHelpers';
import { format } from 'date-fns';

export const trimString = (name: string) => {
  if (name.length > 20) {
    return name.substring(0, 10) + '...' + name.substring(name.length - 7);
  }

  return name;
};

export const trimHash = (hash: string) => {
  if (!hash) return '';

  if (hash.length > 12) {
    return hash.substring(0, 6) + '...' + hash.substring(hash.length - 6);
  }

  return hash;
};

export const UTCToLocalZone = (date: string | Date): string => {
  const d = new Date(date);
  return `${format(d, 'hh:mm:ss a')} @ ${format(d, 'do')} of ${format(d, 'MMMM, yyyy')}`;
};

/**
 * Formats a UTC date in YYYY-MM-DD HH:mm format (keeps UTC time)
 * @param date - The date string or Date object (e.g., "2025-07-01T13:07:55.000Z")
 * @returns Formatted UTC date string (e.g., "2025-07-01 13:07")
 */
export const formatUTCDate = (date: string | Date): string => {
  if (!date) return 'Unknown date';

  const d = new Date(date);

  if (isNaN(d.getTime())) {
    console.error('Invalid date:', date);
    return 'Invalid date';
  }

  // Format as UTC time in YYYY-MM-DD HH:mm format
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  const hours = String(d.getUTCHours()).padStart(2, '0');
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

// export const formattedFileDate = (fileDate: number) => {
//   //FIXME Handle undefined file date correctly
//   if (fileDate === undefined) {
//     return '2000-01-01 00:00:00';
//   }
//   return new Date(fileDate).toISOString().slice(0, 19).replace('T', ' ');
// };

// export const trueFalse = (boolean: boolean) => {
//   if (boolean) {
//     return 1;
//   }

//   return 0;
// };

export const byteToKb = (byte: number) => {
  return parseFloat((byte / 1024).toFixed());
};

/**
 * Converts date format 'RFC 2822' to a SQL-compatible timestamp string without milliseconds or seconds.
 * @param date - The Date object or date string to convert.
 * @returns A string formatted as 'YYYY-MM-DD HH:MM'.
 */
export const dateObjToTimestamp = (date: string | Date): string => {
  // Parse the input to a Date object
  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) {
    throw new Error('Invalid date format');
  }

  // Format and return as 'YYYY-MM-DD HH:MM'
  return parsedDate.toISOString().slice(0, 16).replace('T', ' ');
};

export const dateObjToLocalZone = (date: string | Date): string => {
  // Parse the input to a Date object
  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) {
    throw new Error('Invalid date format');
  }

  // Get local date and time parts
  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(parsedDate.getDate()).padStart(2, '0');
  const hours = String(parsedDate.getHours()).padStart(2, '0');
  const minutes = String(parsedDate.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

// FIXME this might not be necessary? change SQL type to varchar instead of timestamp?
/**
 * Converts date format RFC 2822 'DD/MM/YYYY HH:mm:ss' to a SQL-compatible timestamp string.
 * @param dateStr - The date string to convert.
 * @returns A string formatted as 'YYYY-MM-DD HH:mm:ss'.
 */
// export const mySQLcoindateToTimestamp = (dateStr: string): string => {
//   // Split the date and time parts
//   const [datePart, timePart] = dateStr.split(' ');

//   // Ensure the input is in the expected format
//   if (!datePart || !timePart) {
//     throw new Error('Invalid date format. Expected format: DD/MM/YYYY HH:mm:ss');
//   }

//   // Extract day, month, and year
//   const [day, month, year] = datePart.split('/').map((val) => parseInt(val, 10));

//   // Validate date parts
//   if (!day || !month || !year) {
//     throw new Error('Invalid date components in the input string.');
//   }

//   // Validate time parts
//   const [hours, minutes, seconds] = timePart.split(':').map((val) => parseInt(val, 10));
//   if (hours === undefined || minutes === undefined || seconds === undefined) {
//     throw new Error('Invalid time components in the input string.');
//   }

//   // Construct the SQL-compatible timestamp string
//   const formattedDate = `${year.toString().padStart(4, '0')}-${month
//     .toString()
//     .padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
//   const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
//     .toString()
//     .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

//   return `${formattedDate} ${formattedTime}`;
// };

// Helper function to convert month abbreviation to number
// function getMonthNumber(month: string): string {
//   const months: { [key: string]: string } = {
//     Jan: '01',
//     Feb: '02',
//     Mar: '03',
//     Apr: '04',
//     May: '05',
//     Jun: '06',
//     Jul: '07',
//     Aug: '08',
//     Sep: '09',
//     Oct: '10',
//     Nov: '11',
//     Dec: '12',
//   };
//   return months[month] || '00'; // Return '00' if the month is invalid
// }

// export const convertTimestampDate = (timestamp: number): string => {
//   if (!timestamp || isNaN(timestamp)) {
//     return 'Invalid timestamp';
//   }

//   const date = new Date(Number(timestamp));

//   if (isNaN(date.getTime())) {
//     return 'Invalid date';
//   }

//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   const hours = String(date.getHours()).padStart(2, '0');
//   const minutes = String(date.getMinutes()).padStart(2, '0');
//   const seconds = String(date.getSeconds()).padStart(2, '0');

//   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// };

// export const convertDateFormat = (dateStr) => {
//   // Split the date and time parts
//   const [day, month, yearTime] = dateStr.split('/');
//   const [year, time] = yearTime.split(' ');

//   // Format as 'YYYY-MM-DD HH:MM:SS'
//   return `${year}-${month}-${day} ${time}`;
// };

// export const formatReportDate = (blockchainHistory) => {
//   const latestBlockDate = getEarliestBlockDate(blockchainHistory);
//   const formattedDate = latestBlockDate ? timestampToDateAtTime(latestBlockDate) : 'Unknown Date';
//   return formattedDate;
// };

// export const formatReportDate = (blockchainHistory) => {
//   let cleanedDate;

//   const sortedDates = blockchainHistory.sort((a, b) => new Date(a.DATE) - new Date(b.DATE));

//   cleanedDate = cleanDate(sortedDates[0].DATE);

//   return cleanedDate;
// };

export const cleanDate = (date) => {
  if (date) {
    return date.replace(/\.\d+$/, '');
  }
};

//THIS FUNCTION SENDS

// export const convertDateToSQL = (date) => {
//   let convertedDate = date; // Default to input if no conversion needed

//   // Check if date matches format: "Thu Jan 09 12:26:22 UTC 2025"
//   const explorerApiDatePattern = /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{2}:\d{2}:\d{2} UTC \d{4}$/;

//   if (explorerApiDatePattern.test(date)) {
//     convertedDate = coindateToTimestamp(date);
//   } else {
//     convertedDate = mySQLcoindateToTimestamp(date);
//   }

//   return convertedDate;
// };

/**
 * Converts date format RFC 822 / Unix date e.g. "Tue Jan 28 15:21:21 CET 2025" to
 * 'DD/MM/YYYY HH:mm:ss' to a SQL-compatible timestamp string.
 * @param dateStr - The date string to convert.
 * @returns A string formatted as 'YYYY-MM-DD HH:mm:ss'.
 */
// export const coindateToTimestamp = (inputDateStr: string): string => {
//   // Split the input date string
//   const parts = inputDateStr.split(' ');

//   if (parts.length < 6) {
//     console.error('Invalid date format:', inputDateStr);
//     return null;
//   }

//   const day = parts[2]; // "28"
//   const month = getMonthNumber(parts[1]); // Convert "Jan" → "01"
//   const year = parts[5]; // "2025"
//   const time = parts[3]; // "15:21:21"

//   // Extract hours and minutes
//   const [hours, minutes] = time.split(':');

//   return `${year}-${month}-${day} ${hours}:${minutes}`;
// };

// export const convertTimestampMilli = (timestamp) => {
//   if (!timestamp || isNaN(timestamp)) {
//     return 'Invalid timestamp';
//   }

//   const date = new Date(Number(timestamp));

//   if (isNaN(date.getTime())) {
//     return 'Invalid date';
//   }

//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   const hours = String(date.getHours()).padStart(2, '0');
//   const minutes = String(date.getMinutes()).padStart(2, '0');
//   const seconds = String(date.getSeconds()).padStart(2, '0');

//   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// };

// export const convertTimestampDateMySqlCoins = (dateStr) => {
//   // Split the date and time parts
//   const [day, month, yearTime] = dateStr.split('/');
//   const [year, time] = yearTime.split(' ');

//   // Format as 'YYYY-MM-DD HH:MM:SS'
//   return `${year}-${month}-${day} ${time}`;
// };

/**
 * Removes .json extension and -proof suffix from filename and returns clean filename
 * @param filename - The filename to clean
 * @returns Clean filename without .json extension and -proof suffix
 */
export const cleanFilename = (filename: string): string => {
  if (!filename) return '';

  // Remove .json extension if present
  let cleanName = filename.replace(/\.json$/i, '');

  // Remove -proof suffix if present
  cleanName = cleanName.replace(/-proof$/i, '');

  return cleanName;
};

/**
 * Formats date for PDF filename in YYYY-MM-DD format
 * @param date - The date string or Date object
 * @returns Formatted date string
 */
export const formatDateForFilename = (date: string | Date): string => {
  if (!date) return '';

  const dateObj = new Date(date);

  if (isNaN(dateObj.getTime())) {
    return '';
  }

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
